import React, { useEffect, useRef, useState } from "react";
import api from "../../api";
import HrLayout from "../HrLayout";

export default function AddStudentSkill() {
  const [employees, setEmployees] = useState([]);
  const [employeeId, setEmployeeId] = useState(null);
  const [skillInput, setSkillInput] = useState("");
  const [skills, setSkills] = useState([]);

  // 🔽 custom select states
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  // ================= LOAD EMPLOYEES =================
  useEffect(() => {
    api.get("/employees")
      .then(res => {
        setEmployees(Array.isArray(res.data) ? res.data : []);
      })
      .catch(err => console.error(err));
  }, []);

  // ================= LOAD SKILLS =================
  useEffect(() => {
    if (!employeeId) {
      setSkills([]);
      return;
    }

    api.get(`/skills?employee_id=${employeeId}`)
      .then(res => {
        if (Array.isArray(res.data)) setSkills(res.data);
        else if (Array.isArray(res.data.data)) setSkills(res.data.data);
        else setSkills([]);
      })
      .catch(() => setSkills([]));
  }, [employeeId]);

  // ================= ADD SKILLS =================
  const handleAddSkill = async () => {
    if (!employeeId || !skillInput.trim()) {
      alert("Student aur skills required hai");
      return;
    }

    const skillArray = skillInput
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);

    try {
      for (let skill of skillArray) {
        await api.post("/skills", {
          employee_id: employeeId,
          label: skill,
        });
      }

      setSkillInput("");
      const res = await api.get(`/skills?employee_id=${employeeId}`);
      setSkills(Array.isArray(res.data) ? res.data : []);
    } catch {
      alert("Skill add failed");
    }
  };

  // 🔍 filter employees
  const filteredEmployees = employees.filter(emp =>
    `${emp.first_name} ${emp.last_name}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  // ❌ close dropdown on outside click
  useEffect(() => {
    const handler = e => {
      if (!dropdownRef.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const selectedEmployee = employees.find(e => e.id === employeeId);

  return (
    <HrLayout>
      <div className="max-w-2xl mx-auto bg-white p-6 rounded-2xl shadow-lg">
        <h2 className="text-2xl font-bold mb-6">Add Student Skills</h2>

        {/* ================= SEARCHABLE SELECT ================= */}
        <div className="relative mb-4" ref={dropdownRef}>
          <div
            onClick={() => setOpen(!open)}
            className="border rounded-lg px-3 py-2 cursor-pointer bg-white"
          >
            {selectedEmployee
              ? `${selectedEmployee.first_name} ${selectedEmployee.last_name}`
              : "Select Student"}
          </div>

          {open && (
            <div className="absolute z-20 w-full bg-white border rounded-lg mt-1 shadow-lg">
              <input
                type="text"
                placeholder="Search..."
                className="w-full px-3 py-2 border-b outline-none"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />

              <div className="max-h-48 overflow-y-auto">
                {filteredEmployees.length === 0 && (
                  <p className="px-3 py-2 text-gray-500">
                    No student found
                  </p>
                )}

                {filteredEmployees.map(emp => (
                  <div
                    key={emp.id}
                    onClick={() => {
                      setEmployeeId(emp.id);
                      setOpen(false);
                      setSearch("");
                    }}
                    className="px-3 py-2 hover:bg-blue-100 cursor-pointer"
                  >
                    {emp.first_name} {emp.last_name}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* ================= SKILLS INPUT ================= */}
        <textarea
          placeholder="Enter skills (comma separated)
Example: React, Node.js, MySQL"
          className="w-full border px-3 py-2 mb-4 rounded-lg"
          rows="3"
          value={skillInput}
          onChange={e => setSkillInput(e.target.value)}
        />

        <button
          onClick={handleAddSkill}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg"
        >
          Add Skills
        </button>

        {/* ================= SKILL LIST ================= */}
        <div className="mt-6">
          <h3 className="font-semibold mb-3">Student Skills</h3>

          {skills.length === 0 ? (
            <p className="text-gray-500">No skills added yet</p>
          ) : (
            <ul className="space-y-2">
              {skills.map(skill => (
                <li
                  key={skill.id}
                  className="border px-4 py-2 rounded-lg bg-gray-50"
                >
                  {skill.label}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </HrLayout>
  );
}
